import { render, staticRenderFns } from "./CallTakers.vue?vue&type=template&id=033ec7e0&scoped=true&"
import script from "./CallTakers.vue?vue&type=script&lang=js&"
export * from "./CallTakers.vue?vue&type=script&lang=js&"
import style0 from "./CallTakers.vue?vue&type=style&index=0&id=033ec7e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ec7e0",
  null
  
)

export default component.exports